export default __webpack_public_path__ + "static/media/postImage5.cdac9e3f.png";